/*
 * Copyright 2022-2023 NXGN Management, LLC. All Rights Reserved.
 */

import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import {
  faBook,
  faCalculator,
  faChevronLeft,
  faCog,
  faDesktop,
  faDollarSign,
  faPlus,
  faSearch
} from "@fortawesome/free-solid-svg-icons";
import { faMoneyBillAlt } from "@fortawesome/free-regular-svg-icons";

import { PRACTICE_MODULE_CONSTANT } from "../../../utils/data.rest.constants";
import { AuthService, EventQueueService } from "../../../services";
import { AppEvent } from "../../../models/app-event";
import { AppEventType } from "../../../app-event-type.enum";

@Component({
  selector: "app-side-nav",
  templateUrl: "./side-nav.component.html"
})
export class SideNavComponent implements OnInit {
  constructor(private eventQueueService: EventQueueService, private authService: AuthService) {}

  ngOnInit(): void {
    this.hasFinanceRole = this.authService.canUserAccess("FINANCE");
  }

  practiceIconUrl: string = PRACTICE_MODULE_CONSTANT.PRACTICE_MENU_ICON_PATH;
  hasFinanceRole = false;

  faDesktop = faDesktop;
  faMoney = faMoneyBillAlt;
  faSearch = faSearch;
  faPlus = faPlus;
  faBook = faBook;
  faCalculator = faCalculator;
  faDollarSign = faDollarSign;
  faCog = faCog;
  faChevronLeft = faChevronLeft;

  @Output() menuCollapseEvent = new EventEmitter<boolean>();

  hideMenu(): void {
    this.menuCollapseEvent.emit(true);
    this.eventQueueService.dispatch(new AppEvent(AppEventType.menuCollapse));
  }

  displayPayUi() {
    return (
      window.location.hostname === "d3-py-pay01.dev.medfusion.net" ||
      window.location.hostname === "vip-gwprov.demo.medfusion.net" ||
      window.location.hostname === "localhost"
    );
  }
}
